import { put } from "redux-saga/effects";
import { camelizeKeys } from "lib/helpers";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "../actions";
import messages from "../messages";

function* getSelectedDashboardUpdate(action) {
  const { id } = action.payload;

  const { success, data, error } = yield* makeRequest.get(`/dashboard_updates/${id}`, {});

  if (success && data) {
    yield put(actions.setSelectedDashboardUpdateId(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.GET_POWUR_UPDATES_ERROR,
    });
  }
  return null;
}

export default getSelectedDashboardUpdate;
